export default __webpack_public_path__ + "static/media/Level=1.3cb5e7e1.svg";